export default __webpack_public_path__ + "static/media/speech.81fa608e.jpg";